import { PatientListStreamSortBy } from '@/shared/api/protocol-ts/api/core/svc_patient_pb';
import { PatientsListColumnName } from '@/shared/config';

export const getSortByOptions = (
  sortKey: PatientsListColumnName,
  sortAsc: boolean,
): { By?: PatientListStreamSortBy; Ascending?: boolean }[] => {
  switch (sortKey) {
    case PatientsListColumnName.PatientName:
      return [
        {
          Ascending: sortAsc,
          By: PatientListStreamSortBy.PatientListStreamSortByLastName,
        },
        {
          Ascending: sortAsc,
          By: PatientListStreamSortBy.PatientListStreamSortByFirstName,
        },
      ];

    case PatientsListColumnName.PatientID:
      return [
        {
          Ascending: sortAsc,
          By: PatientListStreamSortBy.PatientListStreamSortByExternalID,
        },
      ];

    case PatientsListColumnName.LastModified:
      return [
        {
          Ascending: sortAsc,
          By: PatientListStreamSortBy.PatientListFiltersSortByLastModified,
        },
      ];

    default:
      return [];
  }
};
